import api from './axios';

export default {
  async findAll() {
    const { data } = await api.get('/categorias-ref');
    return data;
  },
  async save(nome) {
    await api.post('/categorias-ref', { nome });
  },
  async update(id, nome) {
    await api.put(`/categorias-ref/${id}`, { nome });
  },
  async delete(id) {
    await api.delete(`/categorias-ref/${id}`);
  },
};
